import { CustomComponentType } from '../../../enums';
import ExtendedNumber from '../simple-inputs/extended-number/extended-number';

export const generateHiddenRoleFieldComponents = () => [
	ExtendedNumber.schema({ key: `${CustomComponentType.personalInfo}.data.id`, hidden: true, disabled: true }),
	ExtendedNumber.schema({ key: `${CustomComponentType.businessInfo}.data.id`, hidden: true, disabled: true }),
	ExtendedNumber.schema({ key: `${CustomComponentType.farmInfo}.data.id`, hidden: true, disabled: true })
];
